import { isRosterFeatureEnabled } from '@enter/core';

/**
 * Whether the Roster route and nav entry exist in this build — see `isRosterFeatureEnabled`, the
 * same switch the support app uses: on against sandbox, off against production unless
 * `REACT_APP_FEATURE_ROSTER=true`.
 *
 * The two variables are read by name so CRA inlines them at build time; passing `process.env`
 * whole would depend on how the bundler shims it.
 */
export const ROSTER_ENABLED = isRosterFeatureEnabled({
    REACT_APP_FEATURE_ROSTER: process.env.REACT_APP_FEATURE_ROSTER,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
});
